import React from 'react'

import { Text, Link, Dialog } from 'components/ds'
import type { TextProps } from '@radix-ui/themes'

type CancelSubscriptionNeedAssistanceLinkProps = {
  size?: TextProps['size']
}

export function CancelSubscriptionNeedAssistanceLink({
  size,
}: CancelSubscriptionNeedAssistanceLinkProps) {
  return (
    <Text size={size}>
      Need assistance?{' '}
      <Dialog.Close>
        <Link
          href="#"
          className="inline-link"
          data-testid="start-generic-intercom-workflow"
        >
          Chat with support
        </Link>
      </Dialog.Close>
    </Text>
  )
}
